export const env = () => (process.env.REACT_APP_ENV)

export const domain = (key) => {
    const list = {
        tool: {
            url: process.env.REACT_APP_URL,
            ws: process.env.REACT_APP_WS_URL
        },
        pm: {
            url: process.env.REACT_APP_URL_PM,
            ws: process.env.REACT_APP_WS_URL_PM
        },
        psl: {
            url: process.env.REACT_APP_URL_PSL,
            ws: process.env.REACT_APP_WS_URL_PSL
        },
        biz: {
            url: process.env.REACT_APP_URL_BIZ,
            ws: process.env.REACT_APP_WS_URL_BIZ
        },
        mp: {
            url: process.env.REACT_APP_URL_MP,
            ws: process.env.REACT_APP_WS_URL_MP
        },
        hero: {
            url: process.env.REACT_APP_URL_POFHERO,
        },
        api: {
            tool: process.env.REACT_APP_API_URL_TOOL,
            global: process.env.REACT_APP_API_URL_GLOBAL,
            // global: 'https://tpdjwm06fj.execute-api.ap-southeast-1.amazonaws.com/local/global/rqx',
            tb: process.env.REACT_APP_API_URL_TB,
            s3: process.env.REACT_APP_S3_GLBL_API,
        }
    }

    return list[key]
}

export const key = (key) => {
    const list = {
        s3api_key: process.env.REACT_APP_S3_API_KEY,
        gapi_key: process.env.REACT_APP_POF_GLOBAL_API_KEY,
        tapi_key: process.env.REACT_APP_TOOL_API_KEY,
        tbapi_key: process.env.REACT_APP_TB_API_KEY,
        aui_key: process.env.REACT_APP_AUI_KEY,
        tsa_key: process.env.REACT_APP_TSA_KEY,
        tid: process.env.REACT_APP_TID
    }

    return list[key]
}
